<template>
  <div class="evaluate">
    <div class="main">
      <div class="flex main_shop">
        <img :src="info.images" alt />
        <div>
          <div class="dbellipsis">{{info.goods_name}}</div>
        </div>
      </div>
      <div class="rate">
        <div class="flex">
          <div class="rate_name">商品评分</div>
          <van-rate color="#EE0A24" v-model="info.goods_score" />
        </div>
        <div class="flex">
          <div class="rate_name">物流评分</div>
          <van-rate color="#EE0A24" v-model="info.logistics_score" />
        </div>
      </div>
      <div class="eval_content">{{info.content}}</div>
      <div class="comment_img flex">
        <img
          v-for="(item,index) in info.image_arr"
          :key="item"
          :src="item"
          @click="openImagesFg(info.image_arr,index)"
          alt
        />
      </div>
    </div>
    <div class="reply main" v-if="info.reply && info.reply.content">
      <div class="flex-b reply_top">
        <div class="reply_name">回复</div>
        <div class="reply_time">{{info.updated_at_text}}</div>
      </div>
      <div class="reply_main">{{info.reply.content}}</div>
    </div>
    <van-image-preview :startPosition="canvasImg" v-model="isShowImgs" :images="images"></van-image-preview>
  </div>
</template>

<script>
import Vue from 'vue'
import { Rate } from 'vant'

Vue.use(Rate)
export default {
  data() {
    return {
      value: 3,
      info: {},
      isShowImgs: false,
      images: [],
      canvasImg: 0,
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.http('ClientOrderEvaluate.detail', {
        id: this.$route.query.id,
      }).then((e) => {
        this.info = e.content
        console.log(e)
      })
    },
    openImagesFg(e, index) {
      this.canvasImg = index
      console.log(e)
      this.images = e
      this.isShowImgs = true
    },
  },
}
</script>

<style lang="scss" scoped>
.evaluate {
  background: #f7f8fa;
  border-top: 1px solid #f7f8fa;
  min-height: calc(100vh - 1px);
  .main_shop {
    img {
      width: 160px;
      height: 160px;
      border-radius: 10px;
      margin-right: 20px;
    }
    div {
      width: 430px;
      font-size: 26px;
      color: #333333;
      line-height: 38px;
    }
  }
  .rate {
    > div {
      margin-top: 20px;
      align-items: center;
      .rate_name {
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
      }
    }
  }
  .comment_img {
    margin-top: 20px;
    img {
      width: 110px;
      height: 110px;
      border-radius: 20px;
    }
    img + img {
      margin-left: 20px;
    }
  }
}
.main {
  width: 710px;
  border-radius: 20px;
  padding: 20px 40px;
  background: #fff;
  margin: 20px auto 0;
  box-sizing: border-box;
}
// 回复
.reply {
  padding: 0 0 20px;
  .reply_top {
    align-items: center;
    height: 80px;
    padding: 0 40px;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f1f1;
    font-weight: 400;
    font-size: 28px;
    .reply_name {
      color: #333333;
    }
    .reply_time {
      color: #999999;
    }
  }
  .reply_main {
    margin: 25px 40px 0;
    font-size: 22px;
    font-weight: 400;
    color: #666666;
    line-height: 36px;
  }
}
.eval_content {
  font-size: 22px;
  color: #666666;
  line-height: 36px;
  padding: 20px 0;
}
</style>